module.exports = __webpack_public_path__ + "img/page-ico.82fba73e.png";